<div class="date-picker udex-px-sm-0 d-flex">
  <udex-date-picker
    class="date-picker__input"
    [value]="getFormattedDate()"
    [label]="'configurator.startDate' | cxTranslate"
    [maxDate]="maxDate"
    [minDate]="minDate"
    value-state="Standard"
    [disabled]="isDatepickerDisabled$ | async"
    selection-mode="Single"
    (selection-change)="onSelectionChange($any($event))"></udex-date-picker>
  @if (dates.endDate) {
    <div class="date-picker__end-date min-input-height udex-ms-sm-16 body--s">
      <div class="align-self-center">
        <span class="text-grey" data-cy="end-date-label">
          {{ 'configurator.date.endDate' | cxTranslate }}
          @if (dates.endDate) {
            <span>{{ parseDateToFormat(dates.endDate) }}</span>
          }
        </span>
        @if (endDateTooltipContent$ | async) {
          <dcp-icon-button-tooltip
            placement="End"
            [openOnClick]="true"
            [attr.accessible-name]="'durationTooltip'"
            aria-label="durationTooltip">
            <span>{{ endDateTooltipContent$ | async }}</span></dcp-icon-button-tooltip
          >
        }
      </div>
    </div>
  }
  @if (dates.years) {
    <div class="align-self-center">
      <p class="text-grey udex-m-0">
        {{ 'configurator.date.yearsAndMonths' | cxTranslate: dates }}
      </p>
    </div>
  }
</div>
